var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar__section sidebar__section--medium-vertical-padding sidebar__section--border-bottom"},[_c('div',{staticClass:"h4"},[_vm._v("Persönliche Notiz")]),_c('div',{staticClass:"copy-light"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }